import { OnboardingConsent } from '../screens/consent/ConsentToTest';
import { OnboardingTermsOfUse } from '../screens/terms-of-use/TermsOfUse';
import { OnboardingReviewPatientInfo } from '../screens/patient-info/ReviewPatientInfo';
import { OnboardingStep } from '@tempus/patient-web-service-shared';
import { OnboardingIdentityVerification } from '../screens/identity-verification/IdentityVerification';

type OnboardingStepConfig = {
  path: string;
  component: React.ComponentType<{
    next?: () => Promise<void>;
    prev?: () => Promise<void>;
    skip?: () => Promise<void>;
  }>;
  showPrevious?: boolean;
  isFinalStep?: boolean;
};

export const onboardingStepConfig: Record<OnboardingStep, OnboardingStepConfig> = {
  [OnboardingStep.IDENTITY_VERIFICATION]: {
    path: '/onboarding/verify-identity',
    component: OnboardingIdentityVerification,
  },
  [OnboardingStep.TERMS_OF_USE]: {
    path: '/onboarding/terms-of-use',
    component: OnboardingTermsOfUse,
  },
  [OnboardingStep.CONSENT_TO_TEST]: {
    path: '/onboarding/consent-to-test',
    component: OnboardingConsent,
  },
  [OnboardingStep.PATIENT_INFO]: {
    path: '/onboarding/patient-info',
    component: OnboardingReviewPatientInfo,
  },
};
